<template>
<div
   v-closable="{ exclude: [`VehiclePricePerKM_${priceType}`], isClosable: true, handler: 'handleCancelEditing'}"
  >
    <div :ref="`VehiclePricePerKM_${priceType}`"
      class="context--item--editable--input--wrapper"
      :class="{'hovered': isEditing}"
      @mouseover="hover = true"
      @mouseleave="hover = false"
    >
    <div
    @click="handleGlobalEditing"
    class="context--item--editable--input--container"
    :class="[{'editing': isEditing}]">
      <div v-if="icon !== null" class="icon">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">{{ icon }}</v-icon>
          </template>
          <span>{{ iconTooltip }}</span>
        </v-tooltip>
      </div>
      <input
        class="input-price"
        v-show="isEditing"
        :value="localPricePerKM.price"
        :ref="'wrld_editable_input'"
        :placeholder="localPricePerKM.price != null ? localPricePerKM.price : $t('fleet.price') "
        @input="handleInputPrice($event)"
        v-on="listeners"
       />
       <input
        v-model="search"
        v-show="isEditing"
        :ref="'wrld_autocomplete_input'"
        class="input-currency"
        @focus="handleAutoCompleteFocus"
        :placeholder="localPricePerKM.currency != null ? localPricePerKM.currency : $t('fleet.currency') "
        @input="handleInputCurrency"
      />
      <span v-show="!isEditing && isNotNull" class="value">{{ pricePerKM | priceWithCurrency }} {{ pricePerMeasurment }}</span>
      <!-- <span v-show="!isEditing && isNotNull" class="value">{{pricePerKM.currency}}/km</span> -->
      <span v-show="!isNotNull && !isEditing" class="value"> {{ priceEmptyValue }} </span>
    </div>
    <div
    v-show="isEditing && autoCompleteFocus && computedList.length > 0" :ref="'wrld_autocomplete_list'" :class="[`list--height--${computedList.length}`]" class="autocomplete--list"
    :style="autocompleteListStyleObject"
    >
      <ul>
        <template v-for="({ id, text } ,index) in computedList">
          <li @click="handleSelect(index)" :key="id">{{text}}</li>
        </template>
      </ul>
    </div>
    <div v-show="hover" class="actions--panel">
        <template v-if="!isEditing">
          <div class="icon-action">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="14" @click="handleEditing"> fas fa-pen</v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </div>
          <!-- <div class="icon-action">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" size="18" @click="handleCopy"> far fa-copy</v-icon>
              </template>
              <span :key="copied">{{copied ? 'Copied' : 'Copy'}}</span>
            </v-tooltip>
          </div> -->
        </template>
        <template v-else>
          <div class="icon-action">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" @click="handleCancelEditing"> fas fa-times</v-icon>
              </template>
              <span>Cancel</span>
            </v-tooltip>
          </div>
          <div class="icon-action">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" @click="handleSaveEditing"> fas fa-save</v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </div>
        </template>
      </div>
  </div>
</div>
</template>

<script>
import { vehicleService } from '@/_services'
import { mapActions } from 'vuex'
export default {
  name: 'VehiclePricePerKM',
  props: {
    pricePerKM: { type: Object, default: () => null},
    vehicle: { type: Object, default: () => null },
    priceType: { type: String, default: 'Minimal' }
  },
  data () {
    return {
      localPricePerKM: {
        price: null,
        currency: null
      },
      hover: false,
      isEditing: false,
      list: [],
      searchable: ['text'],
      localList: [],
      searchingList: [],
      search: '',
      selected: null,
      autoCompleteFocus: false,
      autocompleteListStyleObject: {}
    }
  },
  created () {
    vehicleService.getCurrencyEnum().then((response) => {
      this.list = response.map((currency) => {
        return {...currency, id: currency.name, text: currency.name}
      })
      this.handleInit()
    })
  },
  methods: {
    ...mapActions({
      setOrganizationVehiclePrice: 'setOrganizationVehiclePrice'
    }),
    handleInit () {
      this.search = ''
      this.localList = []
      this.searchingList = []
      this.localList = [...this.list.map((item) => {
        let itemSearchable = ''
        this.searchable.forEach((key) => {
          itemSearchable += item[key]
        })
        return { ...item, 'text': item['text'], searchable: itemSearchable }
      })]
      if (this.selected === null) {
        const selectedIndex = this.list.findIndex(({ text }) => text === this.value)
        if (selectedIndex > -1) {
          this.selected = JSON.parse(JSON.stringify(this.list[selectedIndex]))
        }
      }
      if (this.selected !== null) {
        this.searchingList = this.localList.filter(({ id }) => id !== this.selected.id)
      } else {
        this.searchingList = [...this.localList]
      }
    },
    handleGlobalEditing () {
      if (!this.isEditing) {
          setTimeout(() => {
            this.$nextTick(() => {
              this.$refs['wrld_editable_input'].focus()
            })
          }, 100)
        }
        this.hover = true
        this.isEditing = true
    },
    handleEditing () {
      this.isEditing = !this.isEditing
      if (this.isEditing) {
        this.hover = true
        this.$nextTick(() => {
          this.$refs['wrld_editable_input'].focus()
        })
      }
    },
    handleCancelEditing () {
      this.localPricePerKM = { ...this.pricePerKM }
      this.isEditing = false
    },
    handleSaveEditing () {
      let priceAttribute = null
      switch (this.priceType) {
        case 'PerEmptyKM':
          priceAttribute = 'pricePerEmptyKM'
          break
        case 'PerFullKM':
          priceAttribute = 'pricePerFullKM'
          break
        case 'Minimal':
          priceAttribute = 'minimalPrice'
          break
      }
      this.setOrganizationVehiclePrice({
        item: { ...this.vehicle, [priceAttribute]: this.localPricePerKM },
        vehicleID: this.vehicle.id,
        pricePerKM: { ...this.localPricePerKM, type: this.priceType }
      })
      this.isEditing = false
    },
    handleInputPrice (evt) {
      this.localPricePerKM = {...this.localPricePerKM, price: evt.target.value}
    },
    handleInputCurrency (evt) {
      this.search = evt.target.value
    },
    handleSelect (index) {
      const indexFound = this.list.findIndex(({ text }) => { return this.computedList[index].text === text })
      this.selected = this.list[indexFound]
      this.search = this.list[indexFound].text
      this.localPricePerKM = {...this.localPricePerKM, currency: this.list[indexFound].text}
      this.autoCompleteFocus = false
    },
    handleAutoCompleteFocus (evt) {
      this.autocompleteListStyleObject = {
        position: 'absolute',
        width: '8%',
        bottom: '100%',
        left: (evt.target.clientWidth + 42) + 'px'
      }
      this.autoCompleteFocus = true
    }
  },
  computed: {
    icon () {
      // switch (this.localPricePerKM.currency) {
      //   case 'EUR':
      //     return 'fas fa-euro-sign'
      //   case 'USD':
      //     return 'fas fa-dollar-sign'
      //   default:
      //     return 'fas fa-coins'
      // }
      switch (this.priceType) {
        case 'PerEmptyKM':
          return 'fas fa-battery-empty'
        case 'PerFullKM':
          return 'fas fa-battery-full'
        default:
          return 'fas fa-coins'
      }
    },
    iconTooltip () {
      switch (this.priceType) {
        case 'PerEmptyKM':
          return this.$t('fleet.PerEmptyKM')
        case 'PerFullKM':
          return this.$t('fleet.PerFullKM')
        default:
          return this.$t('fleet.Minimal')
      }
    },
    priceEmptyValue () {
      switch (this.priceType) {
        case 'Minimal':
          return this.$t('fleet.add_minimal_cost')
        default:
          return this.$t('fleet.add_cost_per_km')
      }
    },
    pricePerMeasurment () {
      switch (this.priceType) {
        case 'Minimal':
          return ''
        default:
          return '/km'
      }
    },
    isNotNull () {
      return (this.localPricePerKM.price != null && this.localPricePerKM.currency != null)
    },
    listeners () {
      return { keyup: (event) => {
          if (event.key === 'Enter') {
            this.handleSaveEditing()
          }
        }
      }
    },
    computedList: function () {
      return this.searchingList
    }
  },
  watch: {
    pricePerKM: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val != null) {
          this.localPricePerKM = { ...this.pricePerKM }
        }
      }
    },
    search: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val.length > 0) {
          this.searchingList = [...this.localList.filter(({ searchable }) => {
            return searchable.toLowerCase().includes(val.toLowerCase())
          })]
        } else {
          this.searchingList = [...this.localList]
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.context--item--editable--input--wrapper {
  position: relative;
  border-radius: 5px;
   width: 100%;
  &.hovered {
     background-color: #f2f2f2;
  }
  &:hover {
    background-color: #f2f2f2;
  }
  .context--item--editable--input--container {
    position: relative;
    padding-left: 5px;
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    flex-wrap: nowrap;
    align-items: left;
    justify-content: flex-start;
    border: 2px solid transparent;
    border-radius: 5px;
    margin-bottom: 1px;
    &.editing {
      border-color: #767676;
    }
    .icon {
      i {
        color: #767676;
        font-size: 16px;
      }
      flex: 1 1 10%;
      margin-right: 15px;
      max-width: 16px;
    }
    .value {
      color: #767676;
      font-size: 13px;
      font-weight: bold;
      flex: 1 1 max-content;
      margin-right: 5px;
      padding-top: 2px;
      &.disabled--link {
        pointer-events: none;
        cursor: default;
      }
    }
    .title {
      padding-top: 5px;
      flex: 1 1 max-content;
      margin-right: 5px;
      margin-left: 5px;
    }
    input {
       &:focus {
        border-bottom: 1px solid #484848 !important;
      }
      &.input-price {
        flex: 1 1 10%;
        max-width: 10%;
      }
      &.input-currency {
        flex: 1 1 10%;
        max-width: 10%;
      }
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
      border-radius: 0;
      -moz-border-radius: 0;
      -webkit-border-radius: 0;
      outline: none;
      border: none;
      background-color: #ededed;
      color: inherit;
      font-family: inherit;
      color: #484848;
      font-size: 13px;
      font-weight: bold;
      width: 40px;
      &.title {
        font-size: 20px;
        padding-top: 0;
      }
    }
  }
  .actions--panel {
    position: absolute;
    right: 3px;
    top: 2px;
    z-index: 9;
    background-color: #f2f2f2;
    height: calc(100% - 5px);
    display: flex;
    border-left: 1px solid #ededed;

    .icon-action {
      position: relative;
      top: 0;
      width: 20px;
      height: 20px;
      text-align: center;
      border-radius: 5px;
      i {
        color: #767676;
        font-size: 16px;
      }
      &:hover {
        background-color: #e0e0e0;
      }
    }
  }
  .autocomplete--list {
    background-color: white;
    width: 100%;
    max-height: 75px;
    overflow-y: auto;
    border-radius: 5px;
    border: 2px solid #767676;
    padding: 0 5px;
    ul {
      list-style-type: none;
      padding: 0;
      li {
        cursor: pointer;
        color: #767676;
        font-size: 13px;
        font-weight: bold;
        margin-bottom: 5px;
        padding-left: 10px;
        border-radius: 5px;
        width: 100%;
        height: 100%;
        z-index: 9;
        &:hover {
          background-color: #f2f2f2;
        }
      }
    }
    z-index: 8;
    position: absolute;
    bottom: 105%;
    &.bottom {
      &.list--height--1 {
        top: -120%;
      }
      &.list--height--2 {
        top: -200%;
      }
      top: 30px;
    }
  }
}

</style>
